var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPreloader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0v3C10.611 3 3 10.611 3 20s7.611 17 17 17c9.28 0 16.825-7.437 16.997-16.677L37 20h3c0 11.046-8.954 20-20 20S0 31.046 0 20C0 9.07 8.769.187 19.656.003L20 0z",
    fill: "#00347A",
    className: "fi-icon-component-brand-fill"
  })));
}

export default SvgIconPreloader;